const AccountTypes = ['bundid', 'passkey', 'totp', 'muk'];
export const isSupportedAccountType = (t) => {
    return AccountTypes.includes(t);
};
